/**
 * Page autonome "Messages étudiants" — accessible aux admins ET aux agents.
 * Réutilise le composant MessagesEtudiantsView pour éviter la duplication.
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Inbox } from 'lucide-react';
import MessagesEtudiantsView from '../Settings/MessagesEtudiantsView';

const MessagesEtudiantsPage: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const allowed = ['super_admin', 'admin', 'agent'].includes(user?.role || '');

  if (!allowed) {
    return (
      <div className="max-w-2xl mx-auto mt-12">
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-8 text-center">
          <Inbox className="w-12 h-12 mx-auto text-gray-400 mb-3" />
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Accès restreint</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
            La messagerie des étudiants est réservée à la scolarité (admins, agents).
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 flex items-center gap-2">
          <Inbox size={22} className="text-blue-600 dark:text-blue-400" />
          Messages étudiants
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Boîte de réception des messages envoyés par les étudiants depuis le portail.
        </p>
      </div>
      <MessagesEtudiantsView />
    </div>
  );
};

export default MessagesEtudiantsPage;
